const TRACK_STATS_CLEANUP_INTERVAL = 10_000;

export default abstract class BaseTrackStatsManager {
  readonly #trackStatsCleanupInterval = TRACK_STATS_CLEANUP_INTERVAL;

  #lastStatsTimestamp = 0;

  #intervalId?: ReturnType<typeof setInterval>;

  protected constructor({ track }: { track: MediaStreamTrack }) {
    this.startCleanupTimer();
    track.addEventListener('ended', () => {
      clearInterval(this.#intervalId);
      this.#intervalId = undefined;
    }, { once: true });
  }

  protected abstract cleanupStats(): void;

  protected touchLastReceivedStatsTimestamp(): void {
    this.#lastStatsTimestamp = Date.now();
  }

  private startCleanupTimer(): void {
    this.#intervalId = setInterval(() => {
      if (this.#lastStatsTimestamp > 0
        && Date.now() - this.#lastStatsTimestamp >= this.#trackStatsCleanupInterval) {
        this.cleanupStats();
      }
    }, this.#trackStatsCleanupInterval);
  }
}
